export default "__VITE_ASSET__BQfu11LM__"